import classnames from 'classnames'
import PropTypes from 'prop-types'
import React, { useEffect, useRef, useState } from 'react'

import { chainDecorators, memoized } from '../../utils/ReactUtils'

import styles from './styles'


const decorators = [
  memoized,
]

function Panel({ className, label, content, isActive, index, handleClick }) {
  const [height, setHeight] = useState(0)
  const ref = useRef(null)
  const innerStyle = { height:  `${isActive ? height : 0}px` }

  useEffect(() => {
    const setPanelHeight = () => {
      if (ref.current) {
        setHeight(ref.current.clientHeight)
      }
    }

    setPanelHeight()
    window.addEventListener('resize', setPanelHeight)

    return () => {
      window.removeEventListener('resize', setPanelHeight)
    }
  }, [])

  return (
    <>
      <div className={classnames('panel', className)} role="tabpanel" aria-expanded={isActive}>
        <div className="heading" onClick={() => handleClick(index)}>
          <button className="label" role={'button'} aria-label={'label'}>{label}</button>
          <button className={classnames('close', isActive ? 'open' : '')} role={'button'} aria-label={'close'} /> 
        </div>
        <div style={innerStyle} className="content" aria-hidden={!isActive}>
          <div className="inner" ref={ref}>
            {content}
          </div>
        </div>
      </div>
      <style jsx>{styles}</style>
    </>
  )
}

Panel.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  content: PropTypes.string,
  isActive: PropTypes.bool,
  index: PropTypes.number,
  handleClick: PropTypes.func
}

Panel.defaultProps = {
  className: null,
  label: null,
  content: null,
  isActive: false,
  index: null,
  handleClick: () => undefined
}

Panel = chainDecorators(decorators, Panel)

export default Panel
